import { IControllerAvailableUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import { UpdateErrorCode } from 'lavva.exalushome/build/js/Services/Updates/IUpdatesService';
import { IconError } from '../../../../../assets/icons/icon-error';
import { IconWarning } from '../../../../../assets/icons/icon-warning';
import { ProcessKey } from '../types';

export const updateErrorCodeMap = {
  [UpdateErrorCode.DeviceIsUpToDate]: { key: 'DeviceIsUpToDate', icon: <IconWarning /> },
  [UpdateErrorCode.CannotFindDevice]: { key: 'CannotFindDevice', icon: <IconError /> },
  [UpdateErrorCode.UnsupportedApiVersion]: { key: 'UnsupportedApiVersion', icon: <IconError /> },
  [UpdateErrorCode.UnsupportedDevice]: { key: 'UnsupportedDevice', icon: <IconError /> },
  [UpdateErrorCode.CannotGetFirmwareVersion]: { key: 'CannotGetFirmwareVersion', icon: <IconError /> },
  [UpdateErrorCode.CannotGetUpdates]: { key: 'CannotGetUpdates', icon: <IconError /> },
  [UpdateErrorCode.CannotProcessUpdate]: { key: 'CannotProcessUpdate', icon: <IconError /> },
  [UpdateErrorCode.UpdateActionsNotSupported]: { key: 'UpdateActionsNotSupported', icon: <IconError /> },
  [UpdateErrorCode.UnsupportedExtensionVersion]: { key: 'UnsupportedExtensionVersion', icon: <IconError /> },
  [UpdateErrorCode.UpdatesPartiallyInstalled]: { key: 'UpdatesPartiallyInstalled', icon: <IconError /> },
  [UpdateErrorCode.ProtocolRadioUnsupported]: { key: 'ProtocolRadioUnsupported', icon: <IconError /> },
  [UpdateErrorCode.CannotGetCurrentControllerVersionTimeout]: {
    key: 'CannotGetCurrentControllerVersionTimeout',
    icon: <IconError />,
  },
  [UpdateErrorCode.CannotGetCurrentControllerVersion]: {
    key: 'CannotGetCurrentControllerVersion',
    icon: <IconError />,
  },
  [UpdateErrorCode.FeatureUnsupportedInCurrentVersion]: {
    key: 'FeatureUnsupportedInCurrentVersion',
    icon: <IconError />,
  },
  [UpdateErrorCode.CannotGetUpdatesBranch]: { key: 'CannotGetUpdatesBranch', icon: <IconError /> },
  [UpdateErrorCode.CannotSetUpdatesBranch]: { key: 'CannotSetUpdatesBranch', icon: <IconError /> },
  [UpdateErrorCode.UpdateAlreadyDownloaded]: { key: 'UpdateAlreadyDownloaded', icon: <IconError /> },
  [UpdateErrorCode.UpdateDownloadFailed]: { key: 'UpdateDownloadFailed', icon: <IconError /> },

  [UpdateErrorCode.UpdateAlreadyInstalled]: { key: 'UpdateAlreadyInstalled', icon: <IconError /> },
  [UpdateErrorCode.CannotGetCurrentControllerVersionTimeout]: {
    key: 'CannotGetCurrentControllerVersionTimeout',
    icon: <IconError />,
  },
  [UpdateErrorCode.CannotGetCurrentControllerVersion]: {
    key: 'CannotGetCurrentControllerVersion',
    icon: <IconError />,
  },
  [UpdateErrorCode.InstallerFileSignCheckFailed]: { key: 'InstallerFileSignCheckFailed', icon: <IconError /> },
  [UpdateErrorCode.UpdateFileSignCheckFailed]: { key: 'UpdateFileSignCheckFailed', icon: <IconError /> },
  [UpdateErrorCode.UpdateFileCheckFailed]: { key: 'UpdateFileCheckFailed', icon: <IconError /> },
  [UpdateErrorCode.UpdateInstallationFailed]: { key: 'UpdateInstallationFailed', icon: <IconError /> },
} as const;

export const getProcessKey = (update: IControllerAvailableUpdateInfo) => {
  if (!update.UpdateIsDownloading && update.DownloadProgress === 100) return ProcessKey.UpdateStart;
  if (!update.UpdateIsDownloading && !update.DownloadProgress) return ProcessKey.DownloadStart;
  if (update.UpdateIsDownloading && update.DownloadProgress > 0 && update.DownloadProgress < 100)
    return ProcessKey.Downloading;

  return null;
};
